export default "__VITE_ASSET__D5U3ifjb__"